import { ValueFormatterParams } from 'ag-grid-community';
import { format, isValid, parseISO } from 'date-fns';

import { DATETIME_FORMAT } from '@/constants';

export function dateTimeFormatter(
  params: { value: string } | ValueFormatterParams<any, string>,
): string {
  const dateValue = params.value;
  if (!dateValue) {
    return '';
  }

  const date = parseISO(dateValue);
  if (!isValid(date)) {
    return '';
  }

  return format(date, DATETIME_FORMAT);
}
